import formModel from './formModel';
import moment from "moment";

const {
    formField: {
        tamanioVivienda,
        tipoVivienda,
        codigosLocalidad,
        descuentoEspecial,
        afinidad,
        deducible,
        coberturas: {
            sumaAsegurada,
            numeroCobertura,
            selectedCobertura
        },
        coberturasAdicionales: {
            sumaAseguradaAdicional,
            numeroCoberturaAdicional,
            selectedCoberturaAdicional
        },
        fechaCotizacion
    }
} = formModel;

export default {
    [tamanioVivienda.name]: "Mediana",
    [deducible.name]: "0",
    [tipoVivienda.name]: "",
    [codigosLocalidad.name]: "",
    [descuentoEspecial.name]: 0,
    [afinidad.name]: '',
    coberturas: [
        {
            [sumaAsegurada.name]: "",
            [numeroCobertura.name]: "1",
            [selectedCobertura.name]: true
        },
        {
            [sumaAsegurada.name]: "",
            [numeroCobertura.name]: "2",
            [selectedCobertura.name]: true
        },
        {
            [sumaAsegurada.name]: "",
            [numeroCobertura.name]: "5",
            [selectedCobertura.name]: true
        },
        {
            [sumaAsegurada.name]: "",
            [numeroCobertura.name]: "17",
            [selectedCobertura.name]: true
        },
        {
            [sumaAsegurada.name]: "",
            [numeroCobertura.name]: "22",
            [selectedCobertura.name]: true
        },
        {
            [sumaAsegurada.name]: "",
            [numeroCobertura.name]: "35",
            [selectedCobertura.name]: true
        },
    ],
    coberturasAdicionales: [
        {
            [sumaAseguradaAdicional.name]: "",
            [numeroCoberturaAdicional.name]: "26",
            [selectedCoberturaAdicional.name]: false
        },
        {
            [sumaAseguradaAdicional.name]: "",
            [numeroCoberturaAdicional.name]: "36",
            [selectedCoberturaAdicional.name]: false
        },
        {
            [sumaAseguradaAdicional.name]: "",
            [numeroCoberturaAdicional.name]: "37",
            [selectedCoberturaAdicional.name]: false
        },
        {
            [sumaAseguradaAdicional.name]: "",
            [numeroCoberturaAdicional.name]: "48",
            [selectedCoberturaAdicional.name]: false
        },
        {
            [sumaAseguradaAdicional.name]: "",
            [numeroCoberturaAdicional.name]: "49",
            [selectedCoberturaAdicional.name]: false
        },
    ],
    [fechaCotizacion.name]: moment().format('YYYY-MM-DD'),
};
